import { validator } from '../../../js/helpers/validator';
export function addressType() {
    const radios = document.querySelectorAll('input[name="address_type"]');
    const checked = document.querySelector('input[name="address_type"]:checked');
    const name = document.querySelector('input[name="name"]');
    const nameBox = name && name.parentNode;
    const nip = document.querySelector('input[name="tax_no"]');
    const nipBox = nip && nip.parentNode;
    const toggle = (radio) => {
        if (radio.value === 'person') {
            nameBox.style.display = 'none';
            nipBox.style.display = 'none';
        }
        else {
            nameBox.style.display = 'flex';
            nipBox.style.display = 'flex';
        }
    };
    if (radios.length) {
        radios.forEach((radio) => {
            radio.addEventListener('change', () => toggle(radio));
        });
        toggle(checked);
    }
}
export function addressValidation() {
    const form = document.querySelector('.users-module .form-address form');
    if (!form)
        return;
    let errors = {};
    form?.addEventListener('submit', (e) => {
        const inputs = form.elements;
        e.preventDefault();
        const { city, first_name, last_name, house_no, phone, region, street, zip_code, country, name, tax_no } = inputs;
        const { between, letters_only, no_special_characters, dash_only, nip, phone: valid_phone, post_code, required } = validator;
        const inputsToValidate = {
            name: {
                validators: [required],
                value: name.value,
            },
            tax_no: {
                validators: [required, nip],
                value: tax_no.value,
            },
            city: {
                validators: [required, between(3, 50), letters_only],
                value: city.value,
            },
            first_name: {
                validators: [required, between(2, 30), letters_only],
                value: first_name.value,
            },
            last_name: {
                validators: [required, between(2, 30), letters_only],
                value: last_name.value,
            },
            house_no: {
                validators: [required],
                value: house_no.value,
            },
            phone: {
                validators: [valid_phone],
                value: phone.value,
            },
            region: {
                validators: [required, letters_only],
                value: region.value,
            },
            street: {
                validators: [required, dash_only],
                value: street.value,
            },
            zip_code: {
                validators: [required, post_code],
                value: zip_code.value,
            },
            country: {
                validators: [required],
                value: country.value
            }
        };
        validateInputs(inputsToValidate, inputs, country.value);
        const isValidated = !Object.values(errors).some(x => (x !== null && x !== ''));
        if (!isValidated)
            return;
        form.submit();
    });
    const validateInputs = (inputsToValidate, inputs, country) => {
        const radio = document.querySelector('input[name="address_type"]:checked');
        errors = {};
        for (let input in inputsToValidate) {
            if ((input === 'name' || input === 'tax_no') && radio.value === 'person')
                continue;
            const inputEl = inputs[input];
            const fieldParent = inputEl.closest('.field');
            fieldParent.classList.remove('has-error');
            fieldParent.querySelectorAll('.error').forEach((error) => error.remove());
            inputsToValidate[input].validators.forEach((validator) => {
                let validationErr;
                if (validator.name === 'post_code' || validator.name === 'phone')
                    validationErr = validator(inputsToValidate[input].value.trim(), country);
                else
                    validationErr = validator(inputsToValidate[input].value.trim());
                if (validationErr) {
                    const errorEl = document.createElement('small');
                    errorEl.classList.add('error');
                    fieldParent.classList.add('has-error');
                    fieldParent.appendChild(errorEl);
                    errors[input] = validationErr;
                    errorEl.textContent = errors[input];
                }
            });
        }
    };
}
